import React, {useEffect, useState} from 'react';
import {Dropdown, Modal, OverlayTrigger, Tooltip} from 'react-bootstrap';
import moment from 'moment';

import {
    addressCreateService,
    addressDeleteService,
    addressListService,
    addressUpdateService
} from '../../services/addressService';
import {Loader} from '../../components/util/Svg';
import Breadcrumb from '../../components/Breadcrumb';
import {countryData} from '../common/commonCountry';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import {CountryDropdown} from 'react-country-region-selector';


const Address = () => {
    const [list, setList] = useState([]);
    const [loader, setLoader] = useState(true);
    const [createModal, setCreateModal] = useState(false);

    const [vatPercent, setVatPercent] = useState('');
    const [vatPercentErr, setVatPercentErr] = useState('');
    const [country, setCountry] = useState('');
    const [countryCode, setCountryCode] = useState('');
    const [countryErr, setCountryErr] = useState('');

    const [showState, setShowState] = useState('0');
    const [showStateErr, setShowStateErr] = useState('');
    const [stateName, setStateName] = useState('');
    const [stateNameErr, setStateNameErr] = useState('');

    const [showCity, setShowCity] = useState('0');
    const [showCityErr, setShowCityErr] = useState('');
    const [cityName, setCityName] = useState('');
    const [cityNameErr, setCityNameErr] = useState('');

    const [showVat, setShowVat] = useState('0');
    const [showVatErr, setShowVatErr] = useState('');

    const [showPostal, setShowPostal] = useState('0');
    const [commonErr, setCommonErr] = useState('');
    const [showPostalErr, setShowPostalErr] = useState('');
    const [postalNameErr, setPostalNameErr] = useState('');
    const [postalName, setPostalName] = useState('');

    const [isDisabled, setIsDisabled] = useState(false);
    const [currentId, setCurrentId] = useState('');


    const breadcrumb = [
        {link: '', linkText: 'Address'}
    ]


    const handleClose = () => {
        setCreateModal(false);

        setCountry();
        setShowVat('0');
        setCountryErr();
        setShowVatErr();

        setPostalName();
        setPostalNameErr();
        setShowPostal('0');
        setShowPostalErr();

        setCityName();
        setCityNameErr();
        setShowCityErr();
        setShowCity('0');

        setStateName();
        setShowStateErr();
        setShowState('0');
        setStateNameErr();

        setCurrentId('');

    }


    const getList = () => {
        let params = ``;
        addressListService(params).then(res => {
            setLoader(false);
            if (res.status) {
                setList(res.data.result)


            }
        })
    }


    useEffect(() => {
        getList();
    }, [])




    const handleValidate = () => {
        let validate = true;

        if (country == '' || country == undefined) {
            setCountryErr('Country is required');

            validate = false
        }

        if (showState == undefined) {
            setShowStateErr('Show state is required');
            setStateNameErr('')
            setCommonErr('')

            validate = false

        }
        if (showState == '1' || showState == 1) {
            setCommonErr('')

            if (stateName == '' || stateName == undefined) {
                setStateNameErr('State name is required');
                validate = false

            } else {
                setStateNameErr('')
            }
        } else {
            setStateNameErr('')

        }


        if (showCity == undefined) {
            setShowCityErr('Show city is required');
            validate = false

        }


        if (showCity == '1' || showCity == 1) {
            setCommonErr('')

            if (cityName == '' || cityName == undefined) {
                setCityNameErr('City name is required');
                validate = false

            } else {
                setCityNameErr('')
            }
        } else {
            setCityNameErr('')

        }
        if (showVat == undefined) {
            setShowVatErr('Show vat is required');
            validate = false

        }
        if (showPostal == undefined) {
            setShowPostalErr('Show postal is required');
            setPostalNameErr('')
            validate = false
            setPostalNameErr('')

        }

        if (showPostal == '1' || showPostal == 1) {
            setCommonErr('')

            if (postalName == '' || postalName == undefined) {
                setPostalNameErr('Postal name is required');
                validate = false

            } else {
                setPostalNameErr('')
            }
        } else {
            setPostalNameErr('')

        }

        if ((showCity != '1' || showCity != 1) && (showPostal != '1' || showPostal != 1) && (showState != '1' || showState != 1)) {
            setCommonErr('All fields cannot be empty ');
            setCityNameErr('')

            validate = false

        } else {
            setCommonErr('')
        }
        return validate;
    }


    const handleSubmit = e => {
        e.preventDefault();
        if (handleValidate()) {
            setIsDisabled(true);
            let params = {};
            let countryCode1='';

            countryData.length && countryData.map((itm, i) => {
                if (country == itm.countryName) {
                    countryCode1=itm.countryShortCode?itm.countryShortCode:''
                }
            })
            params = {

                'country': country,
                'countryCode': countryCode?countryCode:countryCode1,
                'cityName': showCity == 1 ? cityName : '',
                'showCity':Number(showCity),
                'showVat': Number(showVat),
                'stateName': showState == 1 ? stateName : '',
                'showState': Number(showState),
                'postalName': showPostal == 1 ? postalName : '',
                'showPostal': Number(showPostal),
                // 'vatPercent': Number(vatPercent),
                'addressId': currentId ? currentId : '',
                'vatPercent': vatPercent

            }

            let _service = currentId ? addressUpdateService : addressCreateService;

            _service(params).then(res => {
                setIsDisabled(false);
                if (res.status) {
                    handleClose();
                    getList();
                }
            })
        }

    }


    const handleDelete = addressId => {

        setLoader(true);

        // let tempList = list.filter(i => i._id != couponId);
        // setList(tempList);
        let params = {addressId}
        addressDeleteService(params).then(res => {

            if (res.status == 1) {

                getList()
            }
            setLoader(false);

        })
    }


    const handleEdit = item => {
        setCreateModal(true);
        setStateName(item.stateName);
        setShowVat(item.showVat);
        setCountryCode(item.countryCode);
        setShowState(item.showState);
        setCityName(item.cityName);
        setShowCity(item.showCity);
        setShowPostal(item.showPostal);
        setPostalName(item.postalName);
        setVatPercent(item.vatPercent);
        setCountry(item.country);
        setCurrentId(item._id);
    }
    const handleDateChange = (date, dateString) => {

        let dates = new Date()


        let interval1 = moment(date).toDate().setTime(moment(date).toDate().getTime())
        interval1 = Math.floor(interval1 / 1000)
    }

    function disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().endOf('day');
    }

    const dateTimeFormat = (val) => {
        let data = moment(val + (Date.now())).format("DD/MM/YYYY")

        return data;

    }

    const showAdditional = (additional) => {
        let jsx = [];
        additional.length && additional.map((val, i) => {

            jsx.push(<span id={"989i890"}>{val}{i < additional.length ? "," : ""} </span>)
        })
        return jsx;

    }
    const handleFilter = (val) => {
        countryData.length && countryData.map((itm, i) => {
            if (val == itm.countryName) {
                setCountryCode(itm.countryShortCode)
            }
        })

    }

    return (
        <div className="page_wrapper">
            <div className="search_bar">
                <input type="text" className="form-control" placeholder="Search"/>
                <i className="fa fa-search"/>

                <button className="btn btn-primary btn-sm">Search</button>
            </div>

            <Breadcrumb breadcrumb={breadcrumb}/>

            <div className="justifydesign d-flex justify-content-between align-content-center page_header">
                <h2>Address List</h2>
                <span className="btn btn-primary" onClick={() => setCreateModal(true)}>Create</span>
            </div>


            <div className="table-responsive cm_card px-3 py-0 mb-3 cm_table_min_height">
                {loader ? <div className="loader_lg"><Loader/></div> : ''}
                <table className="table user-table table-hover align-items-center">
                    <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Created On</th>

                        <th>Country</th>
                        <th>Country code</th>
                        <th>Show state</th>
                        <th>State name</th>
                        <th>Show city</th>
                        <th>City name</th>
                        <th>Show postal</th>
                        <th>Postal name</th>
                        <th>Show vat</th>
                        <th>Vat %</th>
                        <th>Action</th>


                    </tr>
                    </thead>
                    <tbody>
                    {list && list.map((item, i) => (
                        <tr key={item._id}>
                            <td>{i + 1}</td>
                            <td>{moment(item.created).format('DD MMM, YYYY')}</td>
                            <td>{item.country} </td>
                            <td>{item.countryCode} </td>
                            <td>{item.showState == 1 ? "true" : "false"} </td>
                            <td>{item.stateName} </td>
                            <td>{item.showCity == 1 ? "true" : "false"} </td>
                            <td>{item.cityName} </td>
                            <td>{item.showPostal == 1 ? "true" : "false"} </td>
                            <td>{item.postalName} </td>
                            <td>{item.showVat== 1 ? "true" : "false"} </td>
                            <td>{item.vatPercent} </td>

                            <td>
                                <Dropdown alignRight>
                                    <Dropdown.Toggle className="no_btn"><i className="ellipsis-h"/></Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item href="javascript:void(0)"
                                                       onClick={() => handleEdit(item)}>Edit</Dropdown.Item>
                                        <Dropdown.Item href="javascript:void(0)"
                                                       onClick={() => handleDelete(item._id)}>Delete</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>


            <Modal
                show={createModal}
                onHide={handleClose}
                centered>
                <Modal.Header closeButton>
                    <Modal.Title>Address</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Country</label>

                            <CountryDropdown
                                placeholder="Country"
                                value={country}
                                valueType={"full"}
                                name="country"
                                // onClick={(e) => handleFilter(e,)}
                                onChange={(val) => (handleFilter(val), setCountry(val), setCountryErr(''))}
                                // className="form-control input-lg"
                                className={`form-control ${countryErr ? 'is-invalid' : ''} rounded-pill`}

                            />

                            {countryErr ?
                                <OverlayTrigger placement="left" overlay={<Tooltip>{countryErr}</Tooltip>}>
                                    <span className="error_tootltip"/>
                                </OverlayTrigger> : ''}
                        </div>


                        <div className="form-group">
                            <label>Show state </label>


                            <select
                                value={showState}
                                onChange={e => (setShowState(e.target.value), setShowStateErr(''))}
                                className={`form-control ${showStateErr ? 'is-invalid' : ''} rounded-pill`}>

                                <option value="0">False</option>
                                <option value="1">True</option>
                            </select>


                            {showStateErr ?
                                <OverlayTrigger placement="left" overlay={<Tooltip>{showStateErr}</Tooltip>}>
                                    <span className="error_tootltip"/>
                                </OverlayTrigger> : ''}
                        </div>


                        <div className="form-group">
                            <label>State name</label>

                            <input
                                className={`form-control ${stateNameErr ? 'is-invalid' : ''} rounded-pill`}
                                type="text"
                                maxLength={"35"}
                                value={stateName}
                                onChange={e => (setStateName(e.target.value), setStateNameErr(''))}
                                placeholder="Enter state name"/>


                            {stateNameErr ?
                                <OverlayTrigger placement="left" overlay={<Tooltip>{stateNameErr}</Tooltip>}>
                                    <span className="error_tootltip"/>
                                </OverlayTrigger> : ''}
                        </div>

                        <div className="form-group">
                            <label>Show city</label>

                            <select
                                value={showCity}
                                onChange={e => (setShowCity(e.target.value), setShowCityErr(''))}
                                className={`form-control ${showCityErr ? 'is-invalid' : ''} rounded-pill`}>
                                <option value="0">False</option>
                                <option value="1">True</option>
                            </select>

                            {showCityErr ?
                                <OverlayTrigger placement="left" overlay={<Tooltip>{showCityErr}</Tooltip>}>
                                    <span className="error_tootltip"/>
                                </OverlayTrigger> : ''}
                        </div>


                        <div className="form-group">
                            <label>City name</label>
                            <input
                                maxLength={"35"}

                                className={`form-control ${cityNameErr ? 'is-invalid' : ''} rounded-pill`}
                                type="text"
                                value={cityName}
                                onChange={e => (setCityName(e.target.value), setCityNameErr(''))}
                                placeholder="Enter city name"/>

                            {cityNameErr ?
                                <OverlayTrigger placement="left" overlay={<Tooltip>{cityNameErr}</Tooltip>}>
                                    <span className="error_tootltip"/>
                                </OverlayTrigger> : ''}
                        </div>

                        <div className="form-group">
                            <label>Show vat </label>
                            <select
                                value={showVat}
                                onChange={e => (setShowVat(e.target.value), setShowVatErr(''))}
                                className={`form-control ${showVatErr ? 'is-invalid' : ''} rounded-pill`}>

                                <option value="0">False</option>
                                <option value="1">True</option>
                            </select>

                            {showVatErr ?
                                <OverlayTrigger placement="left" overlay={<Tooltip>{showVatErr}</Tooltip>}>
                                    <span className="error_tootltip"/>
                                </OverlayTrigger> : ''}
                        </div>
                        <div className="form-group">

                            <label>Vat Percentage</label>
                            <input
                                className={`form-control ${vatPercentErr ? 'is-invalid' : ''} rounded-pill`}
                                type="number"
                                value={vatPercent}
                                max={"1000000000"}
                                step="any"
                                onChange={e => (setVatPercent(e.target.value), setVatPercentErr(''))}
                                placeholder="Enter amount"/>

                            {vatPercentErr ? <OverlayTrigger placement="left" overlay={<Tooltip>{vatPercentErr}</Tooltip>}>
                                <span className="error_tootltip"/>
                            </OverlayTrigger> : ''}
                        </div>

                        <div className="form-group">
                            <label>Show postal </label>
                            <select
                                value={showPostal}
                                onChange={e => (setShowPostal(e.target.value), setShowPostalErr(''))}
                                className={`form-control ${showPostalErr ? 'is-invalid' : ''} rounded-pill`}>

                                <option value="0">False</option>
                                <option value="1">True</option>
                            </select>

                            {showPostalErr ?
                                <OverlayTrigger placement="left" overlay={<Tooltip>{showPostalErr}</Tooltip>}>
                                    <span className="error_tootltip"/>
                                </OverlayTrigger> : ''}
                        </div>


                        <div className="form-group">
                            <label>Postal name</label>

                            <input
                                className={`form-control ${postalNameErr ? 'is-invalid' : ''} rounded-pill`}
                                type="text"
                                value={postalName}
                                maxLength={"35"}

                                onChange={e => (setPostalName(e.target.value), setPostalNameErr(''))}
                                placeholder="Enter postal name"/>
                            {postalNameErr ?
                                <OverlayTrigger placement="left" overlay={<Tooltip>{postalNameErr}</Tooltip>}>
                                    <span className="error_tootltip"/>
                                </OverlayTrigger> : ''}
                        </div>
                        {commonErr ? <div style={{"color": "red"}}>{commonErr}</div> : ''}

                        <div className="text-center mt-3">
                            <button disabled={isDisabled} type="submit"
                                    className="btn btn-primary rounded-pill pl-5 pr-5">Submit
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

        </div>
    )
}

export default Address;